// extracted by mini-css-extract-plugin
var _1 = "whatsNew_appIcon__ngGpj";
var _2 = "whatsNew_appStore__KqGiV";
var _3 = "whatsNew_container__mB2tj";
var _4 = "whatsNew_descriptionContainer__2H8pN";
var _5 = "whatsNew_googlePlay__iccfN";
var _6 = "whatsNew_imageContainer__kXoYq";
var _7 = "whatsNew_phoneImage__dt+vk";
var _8 = "whatsNew_store__mOlEM";
var _9 = "whatsNew_textContainer__ATDHI";
export { _1 as "appIcon", _2 as "appStore", _3 as "container", _4 as "descriptionContainer", _5 as "googlePlay", _6 as "imageContainer", _7 as "phoneImage", _8 as "store", _9 as "textContainer" }
